import React, { useState } from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from "@mui/material";
import EditMail from "../../common/EditMail/EditMail";
import ModificaPasswordPage from "../../common/EditPassword/ModificaPasswordPage";
import { useSelector } from "react-redux";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import { useTranslation } from "react-i18next";
import { ROLE } from "../../../utils/constants/profiles";

const ModificaProfiloPage = () => {
  const { t } = useTranslation();
  const state = useSelector((state) => state.app);
  const role = useSelector((state) => state.app.role);

  const [formData, setFormData] = useState({
    [t("Name")]: state.name,
    [t("Surname")]: state.surname,
    Email: state.userEmail,
    [t("Studio")]: state.studioName,
    [t("Role")]: state.role,
  });

  return (
    <div className="flex justify-around mt-10 p-10 w-full items-start">
      <div className="w-5/12">
        <Card className="w-full justify-center">
          <CardHeader
            avatar={
              <Avatar>
                {(
                  formData[t("Name")][0] + formData[t("Surname")][0]
                ).toUpperCase()}
              </Avatar>
            }
            title={
              <Typography variant="h6" fontWeight={700}>
                {t("Data")}
              </Typography>
            }
          />
          <CardContent className="flex flex-col gap-7">
            {Object.entries(formData)
              .filter(([key]) => {
                if (role === ROLE.ADMIN) {
                  return key !== t("Studio");
                }
                return true;
              })
              .map(([key, value]) => (
                <>
                  <div className="w-11/12 flex justify-between">
                    <Typography>{key}</Typography>
                    <Typography
                      fontWeight={700}
                      color={
                        ["Admin", "Studio", "Operator"].includes(value)
                          ? "green"
                          : ""
                      }
                    >
                      {`${t(value)}`}
                    </Typography>
                  </div>
                  <Divider />
                </>
              ))}
          </CardContent>
        </Card>
      </div>

      <div className="flex flex-col w-5/12 gap-5">
        <Card className="w-full justify-center">
          <CardHeader
            avatar={
              <Avatar>
                <MailOutlineRoundedIcon />
              </Avatar>
            }
            title={
              <Typography variant="h6" fontWeight={700}>
                {t("EditMail")}
              </Typography>
            }
          />
          <CardContent>
            <EditMail cardElement={true} />
          </CardContent>
        </Card>

        <Card className="w-full justify-center mt-8">
          <CardHeader
            avatar={
              <Avatar>
                <LockRoundedIcon />
              </Avatar>
            }
            title={
              <Typography variant="h6" fontWeight={700}>
                {t("EditPassword")}
              </Typography>
            }
          />
          <CardContent>
            <ModificaPasswordPage cardElement={true} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ModificaProfiloPage;
